import PromotionsInnerPageA from './PromotionsInnerPageA';
export default PromotionsInnerPageA;
